/* eslint-disable react/prop-types */
import React from "react";
import TextArea from "../../../../component/input/TextArea";

function Observation({ handleInitialState, values }) {
  return (
    <div className="row mt-1 mb-1 ">
      <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 h4">
        <TextArea
          row={2}
          type="text"
          required={false}
          textWhite={false}
          name="generalNotes"
          label="General Notes"
          htmlFor="GeneralNotes"
          value={values.generalNotes}
          placeholder="General Notes"
          onChange={handleInitialState}
        />
      </div>
      <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 h4">
        <TextArea
          row={2}
          type="text"
          required={false}
          textWhite={false}
          name="safetyObservation"
          label="Safety-observation"
          htmlFor="Safety-observation"
          onChange={handleInitialState}
          value={values.safetyObservation}
          placeholder="Safety-observation"
        />
      </div>
      <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 h4">
        <TextArea
          row={2}
          type="text"
          required={false}
          textWhite={false}
          onChange={handleInitialState}
          name="qualityControlObservation"
          htmlFor="QualityControlObservations"
          label="Quality Control Observations"
          value={values.qualityControlObservation}
          placeholder="Quality Control Observations"
        />
      </div>
    </div>
  );
}

export default Observation;
